export const INVOICE_NUMBER_PART_TYPES = ["submission_date", "invoice_date", "supplier_number", "text"];
export const INVOICE_NUMBER_DATE_FORMATS = ["YYYYMMDD", "YYYY-MM-DD", "MMDDYYYY"];
export const DEFAULT_INVOICE_NUMBER_TEMPLATE = {parts: [
    {type: "submission_date", format: "YYYYMMDD"},
    {type: "text", text: "_"},
    {type: "supplier_number"},
]};

/** Validate the bounded template contract shared with the API. */
export const validInvoiceNumberTemplate = (value) => Array.isArray(value?.parts) &&
    value.parts.length > 0 && value.parts.length <= 20 && value.parts.every(part =>
        INVOICE_NUMBER_PART_TYPES.includes(part?.type) &&
        (part.type === "text" ? typeof part.text === "string" && part.text.length > 0 &&
            part.text.length <= 100 && !/[\x00-\x1f]/.test(part.text) :
            !part.type.endsWith("_date") || INVOICE_NUMBER_DATE_FORMATS.includes(part.format)));

/** Show the configured variables, or a deterministic example without customer data. */
export const invoiceNumberTemplateLabel = (value, read, example = false) => (value?.parts || []).map(part => {
    if (part.type === "text") return part.text || "";
    if (!example) return `{${read(`rule.number_${part.type}`)}${part.format ? `: ${part.format}` : ""}}`;
    if (part.type === "supplier_number") return "E1806";
    return {"YYYYMMDD": "20260826", "YYYY-MM-DD": "2026-08-26", "MMDDYYYY": "08262026"}[part.format] || "";
}).join("");
